import { Container } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import AppHeader from "@saleor/components/AppHeader";
import FilterBar from "@saleor/components/FilterBar";
import PageHeader from "@saleor/components/PageHeader";
import { FilterPageProps, ListProps, TabPageProps } from "@saleor/types";
import React from "react";
import { useIntl } from "react-intl";

import { ProductCategoriesBiList_productCategories_edges_node } from "../../types/ProductCategoriesBiList";
import { ProductCategoriesBiList } from "../ProductCategoriesBiList";
import {
  createFilterStructure,
  ProductCategoriesBiFilterKeys,
  ProductCategoriesBiFilterOpts
} from "./filters";

export interface ProductCategoriesBiPageProps
  extends ListProps,
    FilterPageProps<
      ProductCategoriesBiFilterKeys,
      ProductCategoriesBiFilterOpts
    >,
    TabPageProps {
  categories: ProductCategoriesBiList_productCategories_edges_node[];
  onBack: () => void;
  download: () => void;
}

export const ProductCategoriesBiPage: React.FC<ProductCategoriesBiPageProps> = ({
  currentTab,
  filterOpts,
  initialSearch,
  onSearchChange,
  onFilterChange,
  onAll,
  onTabChange,
  onTabDelete,
  onTabSave,
  tabs,
  categories,
  currencySymbol,
  onBack,
  download,
  ...listProps
}) => {
  const intl = useIntl();
  const structure = createFilterStructure(intl, filterOpts);
  return (
    <>
      <Container>
        <AppHeader onBack={onBack}>
          {intl.formatMessage({
            defaultMessage: "Reports",
            description: "reports"
          })}
        </AppHeader>
        <PageHeader title="Product Categories">
          <Button
            color="primary"
            variant="contained"
            disabled={!categories}
            onClick={download}
          >
            Download
          </Button>
        </PageHeader>

        <Card>
          <FilterBar
            allTabLabel={intl.formatMessage({
              defaultMessage: "All",
              description: "tab name"
            })}
            currencySymbol={currencySymbol}
            currentTab={currentTab}
            tabs={tabs}
            filterStructure={structure}
            searchPlaceholder={intl.formatMessage({
              defaultMessage: "Search by Category Name or Code"
            })}
            initialSearch={initialSearch}
            onSearchChange={onSearchChange}
            onFilterChange={onFilterChange}
            onAll={onAll}
            onTabChange={onTabChange}
            onTabDelete={onTabDelete}
            onTabSave={onTabSave}
          />

          <ProductCategoriesBiList categories={categories} {...listProps} />
        </Card>
      </Container>
    </>
  );
};

export default ProductCategoriesBiPage;
